import Vue from 'vue'
import store from '../store/index'

export default class Common {
  localKey = 'vue-session-key'
  serverURL = 'https://cham.vazilmes.com/app'
  socket = null
  stompClient = null
  currentTemperature = 0
  currentHumidity = 0
  headerApiRequest () {
    let header = {
      headers: {
        Authorization: 'bearer ' + store.state.token
      }
    }
    return header
  }
  mobile () {
    let filter = 'win16|win32|win64|mac|macintel'
    if (navigator.platform) {
      if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
        return true
      }
    }
    return false
  }
  setUser (value, saveLocalStorage) {
    let all = this.getAll()
    all.saveLocalStorage = saveLocalStorage
    window.localStorage.setItem(this.localKey, JSON.stringify(all))
    this.setData('user', value)
  }
  clearUser () {
    window.localStorage.setItem(this.localKey, JSON.stringify({}))
    Vue.prototype.$session.clear()
  }

  getUser () {
    return this.getData('user')
  }

  getAll () {
    let all = {}
    try {
      all = JSON.parse(window.localStorage.getItem(this.localKey))
    } catch (e) {
      all = {}
    }
    return all || {}
  }

  setData (key, data) {
    let saveLocalStorage = false
    let all = this.getAll()
    if (typeof all.saveLocalStorage !== 'undefined') {
      if (all.saveLocalStorage === true) {
        saveLocalStorage = true
      }
    }
    if (saveLocalStorage === true) {
      all[key] = data
      window.localStorage.setItem(this.localKey, JSON.stringify(all))
    } else {
      Vue.prototype.$session.set(key, data)
    }
  }

  getData (key) {
    let loadLocalStorage = false
    let all = this.getAll()
    if (typeof all.saveLocalStorage !== 'undefined') {
      if (all.saveLocalStorage === true) {
        loadLocalStorage = true
      }
    }
    if (loadLocalStorage === true) {
      return all[key]
    } else {
      return Vue.prototype.$session.get(key)
    }
  }

  replaceAll (str, searchStr, replaceStr) {
    return str.split(searchStr).join(replaceStr)
  }

  cloneObject (obj) {
    let clone = {}
    for (let i in obj) {
      if (typeof obj[i] === 'object' && obj[i] != null) {
        clone[i] = this.cloneObject(obj[i])
      } else {
        clone[i] = obj[i]
      }
    }
    return clone
    /*
    return JSON.parse(JSON.stringify(obj))
    */
  }
  checkObject (target, source) {
    // 리스트 처리.
    if (Array.isArray(source)) {
      if (target.length === 0) {
        for (let i = 0; i < source.length; i++) {
          let value = source[i]
          target.push(value)
        }
      }
      return
    }

    // 오브젝트 처리.
    let keys = Object.keys(source)
    for (let i = 0; i < keys.length; i++) {
      // 오브젝트, 리스트 처리.
      if (typeof source[keys[i]] === 'object') {
        if (Array.isArray(source[keys[i]])) {
          // list.
          if (typeof target[keys[i]] === 'undefined' ||
            typeof target[keys[i]] !== 'object' ||
            Array.isArray(target[keys[i]]) === false) {
            target[keys[i]] = []
          }
          this.checkObject(target[keys[i]], source[keys[i]])
        } else {
          // Object.
          if (typeof target[keys[i]] === 'undefined') {
            target[keys[i]] = {}
          }
          this.checkObject(target[keys[i]], source[keys[i]])
        }
        continue
      }

      // 초기 데이터 입력.
      if (typeof target[keys[i]] === 'undefined') {
        let value = source[keys[i]]
        target[keys[i]] = value
      }
    }

    /*
    for (let i in source) {
      console.log('----------------------------')
      // console.log(target[i])
      // console.log(typeof target[i])
      if (typeof obj[i] === 'object' && obj[i] != null) {
        clone[i] = this.CheckObject(obj[i])
      } else {
        clone[i] = obj[i]
      }
    }
    */
  }

  getNumber (value) {
    if (value === null) {
      return 0
    }
    switch (typeof value) {
      case 'number' :
        return value
      case 'string' :
        return parseFloat(value)
      default:
        return 0
    }
  }
}
